import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { favorites } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const ENTITY_TO_MODULE_MAPPER = {
  videos: favorites.fetchFavoritesVideos,
  sequences: favorites.fetchFavoritesSequences,
}

const FavoritesLoader = ({
  children,
  fetchMethod,
  activeLanguage: { code: locale },
  ...restProps
}) => (
  <Loader
    fetchMethod={() => fetchMethod({ locale })}
    triggers={[locale]}
    {...restProps}
  >
    {children}
  </Loader>
)

FavoritesLoader.propTypes = {
  children: PropTypes.node.isRequired,
  entity: PropTypes.string.isRequired,
  fetchMethod: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
}

export default compose(
  connect(
    null,
    (dispatch, { entity }) => ({
      fetchMethod: params => dispatch(ENTITY_TO_MODULE_MAPPER[entity](params)),
    })
  ),
  withLocalize
)(FavoritesLoader)
